export default value => {
  return options[value];
};

const options = {
  M: "Male",
  F: "Female"
};
